// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"c35de921","581":"cb2b1df5","750":"f23175c9","787":"436def5c"}[chunkId] + ".chunk.js";
};